import angular = require('angular');

export class LoaderComponent {
}

angular.module('app.common').component('loader', {
  template: require('./loader.component.html'),
  controller: LoaderComponent,
  controllerAs: 'ctrl'
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/components/loader/loader.component.ts